// extracted by mini-css-extract-plugin
export default {"originalPrice":"_950de6ec"};